<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h4>Award</h4>
      <vs-tooltip text="Add" color="primary">
        <vs-button
          type="border"
          color="primary"
          icon="add"
          @click="canAdd()"
        />
      </vs-tooltip>
    </div>
    <div class="table-responsive">
      <table v-if="awardProps.length > 0" class="light_blue_table w-full">
        <tbody>
          <tr :key="indextr" v-for="(item, indextr) in awardProps">
            <td>
              <div v-if="item.picture">
                <img
                  v-if="item.picture.split('.')[item.picture.split('.').length - 1] === 'pdf'"
                  style="width: 40px; height: 40px"
                  src="@/assets/images/file-icons/pdf.png"
                />
                <img
                  v-else
                  style="width: 40px; height: 40px"
                  :src="item.picture"
                />
              </div>
              <div v-else>No Picture Available</div>
            </td>
            <td>
              {{ item.year }}
            </td>
            <td>
              {{ item.award_name }}
            </td>

            <td>
              <p style="max-height: 100px; overflow: auto" class="vertical_scrollbar">{{ item.award_description }}</p>
              <!-- <a v-if="item.award_description" style="white-space: nowrap; cursor: pointer;" class="inline-block" @click="showMore = !showMore">
                <span v-if="showMore">Read More</span>
                <span v-else>Show Less</span>
            </a> -->
            </td>
            <td class="text-right">
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-if="item.picture">
                    <a
                      v-if="item.picture"
                      :href="item.picture"
                      target="_blank"
                      >Preview
                    </a> </vs-dropdown-item
                  ><vs-dropdown-item @click="handleedit(indextr)">
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="remove(indextr)">
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="awardProps.length == 0" class="text-center">
        No Award found
      </div>
    </div>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Are you sure to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="addpopup"
      :class="{ show: addpopup }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>Add Award</h4>
          <button @click="addpopup = false" class="close-modal">&times;</button>
        </div>
        <form data-vv-scope="add">
          <div class="p-4 modal-content">
            <vs-row>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <vs-input
                  v-model="award.year"
                  v-validate="'required|min:4|max:4|numeric'"
                  name="year"
                  label="Year"
                  placeholder="Enter Year"
                  class="w-full mb-4"
                />
                <span v-show="errors.has('add.year')" class="text-danger">{{
                  errors.first("add.year")
                }}</span>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <vs-input
                  v-validate="'required'"
                  name="award-name"
                  v-model="award.award_name"
                  label="Award Name"
                  placeholder="Enter Award Name"
                  class="w-full mb-4"
                />
                <span
                  v-show="errors.has('add.award-name')"
                  class="text-danger"
                  >{{ errors.first("add.award-name") }}</span
                >
              </vs-col>
              <vs-col vs-w="12" class="p-1">
                <label class="vs-input--label">Award Description</label>
                <vs-textarea
                  placeholder="Enter Award Description"
                  class="w-full mb-4"
                  name="award-description"
                  v-model="award.award_description"
                />
              </vs-col>
            </vs-row>
            <div class="w-full">{{ previewImageName }}</div>
            <h6 class="font-semibold mb-2">Upload Certificate (jpeg,jpg,png,pdf)</h6>
            <FileUpload
              :platform_module_id="4"
              @changingImage="saveImage"
            ></FileUpload>
            <div
              style="border-top: 1px solid #cecece"
              class="flex flex-wrap justify-between items-center pt-4"
            >
              <vs-button
                type="border"
                color="danger"
                class="m-1"
                @click="addpopup = false"
                >Cancel</vs-button
              >
              <vs-button class="m-1" @click.prevent="handleSave"
                >Save</vs-button
              >
            </div>
          </div>
        </form>
      </div>
    </div>
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="editpopup"
      :class="{ show: editpopup }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h4>Edit Award</h4>
          <button @click="editpopup = false" class="close-modal">
            &times;
          </button>
        </div>
        <form data-vv-scope="edit">
          <div class="p-4 modal-content">
            <vs-row>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <vs-input
                  v-model="edit.year"
                  v-validate="'required|min:4|max:4|numeric'"
                  name="year"
                  label="Year"
                  placeholder="Enter Year"
                  class="w-full mb-4"
                />
                <span v-show="errors.has('edit.year')" class="text-danger">{{
                  errors.first("edit.year")
                }}</span>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <vs-input
                  v-validate="'required'"
                  name="award-name"
                  v-model="edit.award_name"
                  label="Award Name"
                  placeholder="Enter Award Name"
                  class="w-full mb-4"
                />
                <span
                  v-show="errors.has('edit.award-name')"
                  class="text-danger"
                  >{{ errors.first("edit.award-name") }}</span
                >
              </vs-col>
              <vs-col vs-w="12" class="p-1">
                <label class="vs-input--label">Award Description</label>
                <vs-textarea
                  placeholder="Enter Award Description"
                  class="w-full mb-4"
                  name="award-description"
                  v-model="edit.award_description"
                />
              </vs-col>
            </vs-row>
            <div class="w-full">{{ previewImageName }}</div>
            <h6 class="font-semibold mb-2">Upload Certificate (jpeg,jpg,png,pdf)</h6>
            <FileUpload
              :platform_module_id="4"
              @changingImage="saveImageedit"
              :image="edit.picture"
            ></FileUpload>
            <div
              style="border-top: 1px solid #cecece"
              class="flex flex-wrap justify-between items-center pt-4"
            >
              <vs-button
                type="border"
                color="danger"
                class="m-1"
                @click="editpopup = false"
                >Cancel</vs-button
              >
              <vs-button class="m-1" @click.prevent="handleUpdateAvailiblity"
                >Save</vs-button
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import FileUpload from '@/views/pages/v1/user_profile/components/profile/personal_information/certificateFile.vue'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker'
import { updateClient } from '@/api/client'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  name: 'email',
  components: {
    flatPickr,
    vSelect,
    Datepicker,
    FileUpload
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  props: {
    awardProps: {
      required: true,
      type: Array,
      default: () => []
    },
    clientDetails: {
      default: null
    }
  },
  watch: {
    awardProps: {
      deep: true,
      immediate: true,
      handler () {
        this.awardAvailability = this._.cloneDeep(this.awardProps)
      }
    }
  },
  data () {
    return {
      showMore: true,
      file_url: '',
      previewPopup: false,
      previewImageName: '',
      awardAvailability: [],
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      award: {
        award_description: null,
        award_name: null,
        picture: null,
        year: null
      },
      edit: {
        award_description: null,
        award_name: null,
        picture: null,
        year: null
      },
      editIndex: null,
      deleteindex: false,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      imageDataUrl: null,
      fileName: ''
    }
  },
  methods: {
    canAdd () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addpopup = true
    },
    preview (data) {
      console.log(data)
      this.previewPopup = true
      this.file_url = data
    },
    saveImage (url) {
      if(this.isValidAwardFormat(url)) {
        this.award.picture = url
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'File must be this (jpeg,jpg,png,pdf) type',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'danger'
        })
        this.award.picture = ""
      }
    },
    saveImageedit (url) {
      if(this.isValidAwardFormat(url)) {
        this.edit.picture = url
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'File must be this (jpeg,jpg,png,pdf) type',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'danger'
        })
        this.edit.picture = ""
      }
      
    },
    isValidAwardFormat(filename) {
      const parts = filename.split('.');
      const ext = parts[parts.length - 1];
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'pdf':
          return true;
      }
      return false;
    },
    handlePhonedefault (index) {
      this.awardAvailability.map((item) => {
        item.default = 0
      })
      this.awardAvailability[index].default = 1
    },
    handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = this.award
          this.awardAvailability.push(payload)
          this.handleAwardsave()
        }
      })
    },
    handleedit (index) {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editpopup = true

      this.edit = this.awardAvailability[index]
      this.editIndex = index
    },
    handleUpdateAvailiblity () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.awardAvailability[this.editIndex] = this.edit
        }
        this.handleAwardsave()
      })
    },
    handleDelete () {
      this.awardAvailability.splice(this.deleteindex, 1)
      this.handleAwardsave()
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    uploadImg (e, num, type) {
      const file = e.target.files[0]
      const fileSize = e.target.files[0].size / 1024 / 1024
      const FileType = file.type
      this.fileName = FileType.replace('/', '.')
      if (fileSize < 5) {
        // this.dialogVisible = true
        //
        if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG|PDF)$/.test(e.target.value)) {
          alert('File Should be must this (.gif,jpeg,jpg,png,bmp,pdf) type')
          return false
        }
        const reader = new FileReader()
        reader.onload = (e) => {
          const formData = new FormData()
          formData.append('myFile', file)
          let data = null
          if (typeof e.target.result === 'object') {
            data = new Blob([e.target.result])
            // fd.append('upload_path', 'FeedWall')
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.imageDataUrl = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
        //
      } else {
        this.option.img = ''

        this.dialogVisible = false
        this.$vs.notify({
          title: 'warning',
          text: 'Image sie is too large',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      if (type === 'edit') {
        this.previewImageName = file.name
      }
    },
    async handleAwardsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            award: this.awardAvailability
          }
        }
        const { data } = await updateClient(this.clientDetails.basic_details.client_users_id ? this.clientDetails.basic_details.client_users_id : this.clientDetails.basic_details.id, payload, customer_id)

        this.addpopup = false
        this.award = {
          award_description: null,
          award_name: null,
          picture: null,
          year: null
        }
        this.editpopup = false

        this.deletepopup = false

        this.$emit('setAfterUpdate', data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
    